interface ThicknessSource {
  id: string
  tags: { 'component-dataset'?: string }
  data: { _parquet_column_name?: string }
}

export function inspectionThicknessSource<T extends ThicknessSource>(
  frames: readonly T[],
  datasetId: string,
  column: string | undefined
): T | undefined {
  const candidates = frames.filter(
    (frame) =>
      frame.tags['component-dataset'] === datasetId &&
      (!column || frame.data._parquet_column_name === column)
  )
  // Older saved cards did not carry the backend-selected column.
  return candidates.sort(
    (a, b) =>
      Number(b.data._parquet_column_name === 'min_thickness_1') -
        Number(a.data._parquet_column_name === 'min_thickness_1') ||
      a.id.localeCompare(b.id)
  )[0]
}
